<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        router-link(to='/profile')
          h2 Profile
      v-breadcrumbs-item(disabled)
        h2.ma-0 Edit

  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        template
          v-form(v-model='C.form.validation.overall', ref='form', lazy-validation)
            .pb-5
              .section__title.mb-5
                .subheading
                  | Member Info

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 First name
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.user.firstname', :rules='C.form.validation.rules.user.firstname', single-line, required)

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Last name
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.user.lastname', :rules='C.form.validation.rules.user.lastname', single-line, required)

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Email
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.user.email', :rules='C.form.validation.rules.user.email', single-line, required)

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Citizenship
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.user.citizenship', :items='C.form.list.countries', item-text='name', item-value='alpha3')

            .pb-5
              .section__title.mb-5
                .subheading
                  | Home Address
              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.street1')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address (cont.)
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.street2')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 City
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.city')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 State/Province
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.state_province')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Postal Code
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.postal_code')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Country
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.home_address.country', :items='C.form.list.countries', item-text='name', item-value='alpha3')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Phone
                v-flex(md6)
                  v-text-field.input--box(v-model='C.form.selected.home_address.phone_number', label='Phone', bottom='', hide-details)

            .pb-5
              .section__title.mb-5
                .subheading
                  | Work Address
              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Employer
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.employer')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.street1')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address (cont.)
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.street2')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 City
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.city')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 State/Province
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.state_province')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Postal Code
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.postal_code')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Country
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.work_address.country', :items='C.form.list.countries', item-text='name', item-value='alpha3')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Phone
                v-flex(md6)
                  v-text-field.input--box(v-model='C.form.selected.work_address.phone_number', label='Phone', bottom='', hide-details)

        v-divider.my-3
        v-layout(row)
          v-flex(md3)
          v-flex(md6)
            v-btn.ml-0(@click='C.form.trigger.submit', :disabled='!C.form.validation.overall', color='primary')
              | Update
            v-btn(to='/profile', exact, outline, color='primary')
              | Cancel

</template>

<script>
  import tools from '../../assets/tools.js'
  import axios from '../../../node_modules/axios/dist/axios.js'
  import Multiselect from 'vue-multiselect'
  import countryData from 'country-data'

  export default {
    components: {
      Multiselect
    },
    computed: {
      binding () {
        const binding = {}
        if (this.$vuetify.breakpoint.smAndDown) binding.column = true
        return binding
      }
    },
    data () {
      return {
        CR: {},
        C: {
          data: {
            profile: {}
          },
          form: {
            validation: {
              overall: false,
              rules: {
                user: {
                  firstname: [
                    (v) => !!v || 'First name is required'
                  ],
                  lastname: [
                    (v) => !!v || 'Last name is required'
                  ],
                  email: [
                    (v) => !!v || 'Email is required'
                  ]
                }
              }
            },
            selected: {
              user: {
                firstname: '',
                lastname: '',
                email: '',
                citizenship: ''
              },
              home_address: {
                street1: '',
                street2: '',
                city: '',
                state_province: '',
                postal_code: '',
                country: '',
                phone_number: ''
              },
              work_address: {
                employer: '',
                street1: '',
                street2: '',
                city: '',
                state_province: '',
                postal_code: '',
                country: '',
                phone_number: ''
              }
            },
            list: {
              countries: countryData.countries.all
            },
            trigger: {
              submit: () => {
                var component = this

                var submitItem = {
                  user: this.C.form.selected.user,
                  home_address: this.C.form.selected.home_address,
                  work_address: this.C.form.selected.work_address
                }

                function completeUpdateProcess (resultsItem) {
                  console.info('Profile Update Results: ', resultsItem)

                  component.$router.push({
                    name: 'Profile'
                  })

                  tools.alert({
                    type: 'success',
                    message: `Your profile has been updated.`
                  })
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/people/self_update`, submitItem)
                  .then(function (response) {
                    var userUpdateData = response.data

                    completeUpdateProcess({
                      user: userUpdateData
                    })
                  })
                  .catch(function (errorResponse) {
                    tools.alert({
                      type: 'error',
                      errorResponse: errorResponse
                    })
                  })
              }
            }
          }
        }
      }
    },
    created () {
      var component = this

      tools.loggedInData({
        success: function (loggedInItem) {
          component.C.data.person = loggedInItem.data

          component.C.form.selected.user.firstname = loggedInItem.data.firstname
          component.C.form.selected.user.lastname = loggedInItem.data.lastname
          component.C.form.selected.user.email = loggedInItem.data.email
          component.C.form.selected.user.citizenship = loggedInItem.data.citizenship || 'USA'
          component.C.form.selected.home_address = loggedInItem.data.home_address || {}
          component.C.form.selected.work_address = loggedInItem.data.work_address || {}

          component.C.form.selected.home_address.country = component.C.form.selected.home_address.country || 'USA'
          component.C.form.selected.work_address.country = component.C.form.selected.work_address.country || 'USA'
        },
        error: function (errorResponse) {
          tools.alert({
            type: 'error',
            errorResponse: errorResponse
          })
        }
      })
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .side-drawer {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/ProfileEdit.vue